/*eslint no-unused-vars:0, new-cap:0 */

/**
 * Dust template renderer and loader.
 */

'use strict';

exports.__esModule = true;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _ajax = require('./ajax');

var ajaxLoader = _interopRequireWildcard(_ajax);

var _dustjsLinkedin = require('dustjs-linkedin');

var _dustjsLinkedin2 = _interopRequireDefault(_dustjsLinkedin);

// assume helpers are loader by now...

/**
 * An abstract view renderer implementation that's based on Promises
 * @constructor
 */

var ViewRenderer = (function () {
	function ViewRenderer() {
		_classCallCheck(this, ViewRenderer);
	}

	/**
  * A Dust view rendering implementation
  * @constructor
  */

	/**
  * The main public API for rendering a template
  * @param template the name of the template to render
  * @param context the context to pass to the renderer
  * @returns a Promise
  */

	ViewRenderer.prototype.render = function render(template, context) {
		// TODO: switch this to a Promise, just remember
		// base-view and others rely on .fail(), .done(),
		// and .always() so we'll need to be careful to
		// port all of that functionality over properly
		var deferred = new _jquery2['default'].Deferred();
		this._doRender(template, context, function (error, out) {
			if (error) {
				return deferred.reject(error);
			}
			deferred.resolve(out, template);
		});
		return deferred.promise();
	};

	/**
  * The method to override to provide the view rendering implementation
  * @private
  * @param template the name of the template to render
  * @param context the content to pass to the renderer
  * @param callback the callback invoked when rendering is complete
  */

	ViewRenderer.prototype._doRender = function _doRender(template, context, callback) {
		// TODO: Implement
	};

	return ViewRenderer;
})();

var DustRenderer = (function (_ViewRenderer) {
	_inherits(DustRenderer, _ViewRenderer);

	function DustRenderer(nougat) {
		_classCallCheck(this, DustRenderer);

		_ViewRenderer.call(this);
		var DEFAULT_PATH = '/templates/%s.js';

		// override dust.onLoad to pull templates up over the wire
		_dustjsLinkedin2['default'].onLoad = function (name, callback) {
			var path = nougat.getContext().templatePath || DEFAULT_PATH;
			var template = path.replace('%s', name);

			if (_dustjsLinkedin2['default'].cache[template]) {
				return setTimeout(callback, 0);
			}

			return ajaxLoader.script(template, callback);
		};
	}

	DustRenderer.prototype._doRender = function _doRender(template, context, callback) {
		if (context === undefined) context = {};

		var base = {};

		// Ugh.
		if (context.content) {
			base.cn = context.content;
			delete context.content;
		}

		context = _dustjsLinkedin2['default'].makeBase(base).push(context);
		_dustjsLinkedin2['default'].render(template, context, callback);
	};

	return DustRenderer;
})(ViewRenderer);

var Nougat = (function () {
	function Nougat() {
		_classCallCheck(this, Nougat);

		this._context = {};
		this._eventCache = {};
		this.viewRenderer = new DustRenderer(this);
	}

	/**
  * Sets the context
  * @param context
  * @returns the context
  */

	Nougat.prototype.setContext = function setContext(context) {
		return Object.assign(this._context, context);
	};

	/**
  *
  * @returns the current context object
  */

	Nougat.prototype.getContext = function getContext() {
		return this._context;
	};

	/**
  *
  * @returns the template path directory excluding language
  */

	Nougat.prototype.getTemplateBasePath = function getTemplateBasePath() {
		var context = this.getContext();
		var oldPath = context.templatePath;
		var fileType = '/%s.js';

		// templates are either on /templates/{country} or paypalobjects.com/{md5hash}/{country}
		var pathLength = oldPath.lastIndexOf('/', oldPath.length - fileType.length - 1);
		var templateDirectory = oldPath.substring(0, pathLength) + '/';

		return templateDirectory;
	};

	return Nougat;
})();

exports['default'] = new Nougat();
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /workspace/donate-gro-release/~/forklifter/dist/renderer.js
// module id = 190
// module chunks = 0 1 2 3 4 5 6